// extracted by mini-css-extract-plugin
export default {"container":"ExpensesTab_container__jCcqG","header":"ExpensesTab_header__r0I07","error":"ExpensesTab_error__-jtx8"};